import { Box, Typography } from '@mui/material';
import { accessCouponChevronSrc } from '../../assets/bazzar';

/** Figma 10349:57049 — Access Coupon button */
export const ACCESS_COUPON_BUTTON_WIDTH = 328;
export const ACCESS_COUPON_BUTTON_HEIGHT = 38;

export default function AccessCouponButton({
  onClick,
  disabled = false,
  maxWidth = ACCESS_COUPON_BUTTON_WIDTH,
  sx,
}) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Access Coupon"
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth,
        height: ACCESS_COUPON_BUTTON_HEIGHT,
        mx: 'auto',
        border: 0,
        borderRadius: '12px',
        p: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        bgcolor: 'transparent',
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          bgcolor: 'rgba(0, 0, 0, 0.5)',
          pointerEvents: 'none',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '5px',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontFamily: 'Inter, sans-serif',
            color: '#ff00f2',
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '22px',
            letterSpacing: 0,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          }}
        >
          Access Coupon
        </Typography>
        <Box
          component="img"
          src={accessCouponChevronSrc}
          alt=""
          sx={{ width: 15, height: 10, display: 'block', flexShrink: 0 }}
        />
      </Box>

      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          boxShadow: 'inset 0 4px 4px rgba(0, 0, 0, 0.55)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}
